<template>
    <div class="order-status">
        <div class="status-container">
            <h2 class="title">{{ order.title }}</h2>
            <p class="order-no">订单号：{{ order.order_no }}</p>
            <p class="date" >创建日期：{{ order.create_time }}</p>
            <p class="amount">金额：￥{{ getOrderAmount() }}</p>
            <p class="status">状态：{{ getStatusText(order.status) }}</p>
        </div>
        <div v-if="order.status === 0" class="bottom-actions">
            <el-button type="primary" @click="fetchOrder(true)" style="margin-bottom: 10px;">我已经完成支付</el-button>
            <el-button @click="redirectPayPage()">还未支付，前往支付宝付款</el-button>
        </div>
        <div v-else-if="order.status === 1" class="bottom-actions">
            <p>订单预计将在1分钟内完成结算……</p>
        </div>
        <div v-else-if="order.status === 4" class="bottom-actions">
            <p>订单已完成，前往<span class="link" @click="goToAccount">我的套餐</span>查看套餐信息</p>
        </div>
        <div style="display: flex; align-items: center;flex-direction: column;">
            <div>
                <p>如有遇到支付异常，请微信扫码联系客服处理</p>
            </div>
            <img style="width:300px; height: 300px;" :src="src" alt="微信扫码添加客服" />
        </div>
    </div>
</template>
  
<script>
import { OrderAPI } from '../api/order';

export default {
    data() {
        return {
            order: {},
            src: require('@/assets/images/aaron_plus_wx.jpg'),
        };
    },
    computed: {
        orderNo() {
            return this.$route.params.orderNo;
        }
    },
    mounted() {
        this.fetchOrder();
    },
    methods: {
        fetchOrder(showMsg) {
            const orderData = {
                order_no: 'dev-2023051415000001',
                title: 'gpt3.5-月套餐-100w字-新购-1个月',
                origin_price: 1,
                real_price: 1,
                status: 0,
                pay_expire: '2023-05-14 15:15:02',
                pay_time: '2023-05-14 15:15:02',
                create_time: '2023-05-14 15:00:01',
            };

            OrderAPI.queryOrderInfo(this.orderNo).then(res => {
                this.order = res
                if (showMsg) {
                    this.$message.success("订单状态已刷新")
                }
            }).catch(e => {
                this.$router.replace('/order')
            })
        },
        getStatusText(status) {
            const statusMap = {
                0: "待支付",
                1: "已支付",
                2: "已取消",
                3: "已超时",
                4: "已完成"
            };
            return statusMap[status] || "";
        },
        getOrderAmount() {
            return (this.order.real_price / 100).toFixed(2);
        },
        goToAccount() {
            this.$router.replace('/account');
        },
        redirectPayPage() {
            // 跳转到支付页面
            OrderAPI.prepayOrder(this.orderNo).then(res => {
                this.openNewTab(res.pay_html)
            })

        },
        openNewTab(htmlText) {
            // 创建一个新的窗口
            const newWindow = window.open();

            // 给新窗口设置HTML内容
            newWindow.document.write(`
                <html>
                <body>
                    ${htmlText}
                </body>
                </html>
            `);
        }
    },
};
</script>
  
<style scoped>
.order-status {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: column;
    height: 100vh;
    background-color: #fff;
}

.status-container {
    text-align: center;
    margin-bottom: 20px;
}

.title {
    font-size: 18px;
    font-weight: bold;
    color: #639;
}

.order-no,
.date,
.amount,
.status {
    margin-bottom: 10px;
}

.bottom-actions {
    text-align: center;
    margin-top:
        20px;
}

.link {
    color: #639;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Order.vue